<div class="visor" *ngIf="abierto">
    <div class="visor-barra">
        <div class="visor-titulo">
            <span class="visor-nombre">{{ foto?.nombre }}</span>
            <span class="visor-contador" *ngIf="fotos.length > 1">
                {{ indice + 1 }} / {{ fotos.length }}
            </span>
        </div>
        <div class="visor-acciones">
            <button
                type="button"
                class="visor-boton"
                (click)="alternarZoom()"
                [attr.aria-label]="ampliada ? 'Ver la foto entera' : 'Ampliar'">
                <i class="fa" [class.fa-search-plus]="!ampliada" [class.fa-search-minus]="ampliada"></i>
            </button>
            <!--
                Un enlace normal, no un fetch a un blob: el backend manda
                `Content-Disposition: attachment`, así que el navegador guarda
                el fichero sin salir de la aplicación y sin cargárselo en
                memoria, que en una tablet con una foto de varios megas importa.

                `target="_blank"` por si la respuesta no es el fichero —firma
                caducada, montaje caído—: así la página de error no se lleva por
                delante la aplicación. Si es el fichero, la pestaña se cierra
                sola.
            -->
            <a
                class="visor-boton"
                [href]="foto?.urlDescarga"
                [attr.download]="foto?.nombre"
                target="_blank"
                rel="noopener"
                aria-label="Descargar">
                <i class="fa fa-download"></i>
            </a>
            <button
                type="button"
                class="visor-boton visor-cerrar"
                (click)="cerrar()"
                aria-label="Cerrar">
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>

    <div
        class="visor-lienzo"
        #lienzo
        (pointerdown)="alPulsar($event)"
        (pointerup)="alSoltar($event)"
        (pointercancel)="alCancelar($event)">
        <app-loader class="visor-cargando" *ngIf="cargando && !fallo"></app-loader>

        <div class="visor-fallo" *ngIf="fallo">
            <i class="fa fa-triangle-exclamation"></i>
            <p>No se ha podido cargar la foto.</p>
        </div>

        <img
            *ngIf="foto"
            [src]="foto.urlVer"
            [alt]="foto.nombre"
            [style.transform]="transformacion"
            [class.visor-oculta]="cargando || fallo"
            (load)="imagenCargada()"
            (error)="imagenFallida()"
            draggable="false" />
    </div>

    <button
        type="button"
        class="visor-flecha visor-flecha-izq"
        *ngIf="hayAnterior && !ampliada"
        (click)="ir(-1)"
        aria-label="Foto anterior">
        <i class="fa fa-chevron-left"></i>
    </button>
    <button
        type="button"
        class="visor-flecha visor-flecha-der"
        *ngIf="haySiguiente && !ampliada"
        (click)="ir(1)"
        aria-label="Foto siguiente">
        <i class="fa fa-chevron-right"></i>
    </button>

    <div class="visor-pie" *ngIf="foto?.descripcion">
        {{ foto?.descripcion }}
    </div>
</div>
